import { findOnixItemByValue, withPreferredFirst, } from "./selectMappers";
/**
 * ONIX Primary content type (codetable 81) code for "Hudebnina" (music
 * notation). Hidden from the picker on existing non-music products.
 */
export var MUSIC_NOTATION_CONTENT_TYPE = "11";
/** ONIX Primary content type (codetable 81) code for "Text". */
export var PRIMARY_CONTENT_TYPE_TEXT = "10";
/**
 * ONIX Primary content type (codetable 81) code hoisted to the top of the
 * picker as the most frequently used binding: "10" (Text). Only Text is
 * prioritised — every other option (incl. Audiokniha "01") keeps its order.
 */
export var PREFERRED_PRIMARY_CONTENT_TYPE_CODES = [PRIMARY_CONTENT_TYPE_TEXT];
/**
 * Builds the ordered list of Primary content type (ONIX codetable 81) options
 * shown in the picker.
 *
 * The backend delivers the items ordered by raw ONIX code, which places
 * Audiokniha ("01") ahead of Text ("10"). This first hides music notation
 * ("11") on existing non-music products, then hoists Text to the front so the
 * most frequently used binding leads the offer, while Audiokniha stays in the
 * list (just no longer at the top). Filtering runs before hoisting so the
 * remaining options keep their original relative order.
 *
 * @param items the codetable items as delivered by the backend
 * @param options product state controlling music-notation visibility
 * @return a new array with Text first, followed by the remaining options
 */
export var buildPrimaryContentTypeItems = function (items, options) {
    var showMusicNotation = options.isNewProduct ||
        options.currentValue === MUSIC_NOTATION_CONTENT_TYPE;
    var filtered = items.filter(function (item) { return item.value !== MUSIC_NOTATION_CONTENT_TYPE || showMusicNotation; });
    return withPreferredFirst(filtered, PREFERRED_PRIMARY_CONTENT_TYPE_CODES);
};
/**
 * Default Primary content type (ONIX codetable 81) for a freshly created
 * product: the type locked by the title's existing products wins; otherwise
 * "Text" (10) matched by its ONIX code (never by array index); otherwise
 * nothing, so the picker shows its placeholder and the user must choose.
 *
 * Deliberately never falls back to the first codetable item (Audiokniha "01"),
 * unlike {@link firstOnix}/{@link preferredOnix}. Shared by both product-create
 * paths (full-page ProductCreate and the title panel's create modal) so their
 * defaults cannot drift apart again.
 *
 * @param source codetable wrapper or raw item array
 * @param lockedType primary content type required by the title's existing products
 * @return the default item, or undefined when the field should stay empty
 */
export var defaultPrimaryContentType = function (source, lockedType) {
    return lockedType !== null && lockedType !== void 0 ? lockedType : findOnixItemByValue(source, PRIMARY_CONTENT_TYPE_TEXT);
};
